module.exports = __webpack_public_path__ + "static/media/service-img-08.95c9d3d2.png";